export default __webpack_public_path__ + "static/char-s-48-zh-Hans-3ae79297a057485daf3270356c9a8e79.png";